(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["igc-announcement-bar"]) return;
  try {
    
  let abar = document.querySelector('.announcementbar');
  if (abar) {
    window.addEventListener('scroll', ()=> {
      if(window.scrollY > 0) {
        abar.classList.add('scrolled');
      } else {
        abar.classList.remove('scrolled');
      }
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["igc-cart"]) return;
  try {
    

  let cartitemsallqtys = document.querySelectorAll('.c-cart__qty__field');

  let checkoutbutton = document.querySelector('#checkout');
  let updatebutton = document.querySelector('#update');

  console.log(updatebutton);
  console.log(checkoutbutton);
  
  updatebutton.style.display = 'none';
  
  if(cartitemsallqtys.length > 0) {
    cartitemsallqtys.forEach((itemqty)=>{
      console.log(itemqty);
      itemqty.addEventListener('change',()=>{
        console.log('change');
        checkoutbutton.style.display = 'none';
        updatebutton.style.display = 'block';
      })
    });
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["igc-contact-v2"] && !Shopify.designMode) return;
  try {
    
  function enquiryModal() {

    let contactModal = document.querySelector('#enquirymodal');
    let triggerbuttons = document.querySelectorAll('.showroomenquiry');
  
    let body = document.querySelector('body');

    if(!contactModal || !triggerbuttons) return;

    let enquiryFormLocation = contactModal.querySelector('#location');
    


    openElements();
  
    function openElements() {
      
      console.log(triggerbuttons);
      triggerbuttons.forEach( function(trig) {
        trig.addEventListener('click', function() {
                                enquiryFormLocation.value = trig.dataset.location;
                                showModal();
                              });
      })
      
    }

    closureElements();
  
    function closureElements() {
      
      let UL = contactModal.querySelector('.underlayer');
      if(UL) {
        UL.addEventListener('click', closeModal);
      }
      let CLS = contactModal.querySelector('.cross');
      if(CLS) {
        CLS.addEventListener('click', closeModal);
      }
    }

    // Check if form posted on loading, show, then close form.
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    if(params.has("contact_posted")) {
      setTimeout(showModal,400);
      setTimeout(closeModal, 5000);
    }

    function showModal() {
      body.classList.add('noscroll');
      contactModal.classList.add('active');
      contactModal.querySelector('#first_name').focus();
    }

    function closeModal() {
      body.classList.remove('noscroll');
      contactModal.classList.remove('active');
    }
  
  }
  document.addEventListener("DOMContentLoaded", enquiryModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["igc-mod-splash-slides"] && !Shopify.designMode) return;
  try {
    


  let slideSection = document.querySelector('#splashslideshow');
  if(!slideSection) { return; }

  let controls,btnNext,btnPrev,activeNum=0;
  
  let slides = slideSection.querySelectorAll('.splashslideshow__slide');
  let activeSlide = slideSection.querySelector('.splashslideshow__slide.active');

  if(activeSlide) {
    let activeNum = activeSlide.dataset.slidecount;
  }
  let numSlides = parseInt(slides.length);


  buttonControls();
  checkPositionInSlides();

  function buttonControls() {
    
    controls = slideSection.querySelector('.controls');
    btnNext = controls.querySelector('.next');
    btnPrev = controls.querySelector('.prev');

    if(!btnNext || !btnPrev) { return; }

    btnNext.addEventListener('click', ()=>{
      if(checkEnd()) {
        slideChange('next');
      }
    });

    btnPrev.addEventListener('click', ()=>{
      if(checkStart()) {
        slideChange('prev');
      }
    });
  }

  function checkPositionInSlides() {

    let parsedTotal = parseInt(numSlides - 1);
    
    if(activeNum == parsedTotal) {
      btnNext.classList.add('hidden');
    } else {
      btnNext.classList.remove('hidden');
    }

    if(activeNum == 0) {
      btnPrev.classList.add('hidden');
    } else {
      btnPrev.classList.remove('hidden');
    }
    
  }

  function checkEnd() {
    if(activeNum == numSlides) {
      return false;
    } else {
      return true;
    }
  }

  function checkStart() {
    if(activeNum == 0) {
      return false;
    } else {
      return true;
    }
  }

  function slideChange(type) {
    
    activeSlide.classList.remove('active');

    slides.forEach( (slide)=>{
      slide.classList.remove('toLeft');
      // pause all videos
      let slideVideo = slide.querySelector('video');
      if(slideVideo) {
        slideVideo.pause();
      }
    });
    
    let activeShift;
    
    if(type == 'next') {
      activeShift = parseInt(activeNum + 1);
    } else {
      activeShift = parseInt(activeNum - 1);
    }

    let theTarget = slides[activeShift];
    // Check for video and play, before animating;
    let activeVideo = theTarget.querySelector('video');
    if(activeVideo) { 
      activeVideo.play();
    }
    

    theTarget.classList.add('active');
    activeSlide = theTarget;

    activeNum = activeShift;

    if(activeNum != 0) {
      slides[activeNum-1].classList.add('toLeft');
    }

    checkPositionInSlides();

     
    
  }

  function restartVideo(theVideo) {
    theVideo.pause();
    theVideo.currentTime = 0;
    theVideo.play();
  }



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
